import _ from 'underscore'
import { TextField, Typography } from '@mui/material'
import React, { useState, useCallback } from 'react'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import makeStyles from '@mui/styles/makeStyles'
import Checkbox from '@mui/material/Checkbox'
import Menu from '@mui/material/Menu'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import Button from '@mui/material/Button'
import Hidden from '@mui/material/Hidden'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import clsx from 'clsx'
import { useGetIdsReferencesHcsroles, useGetIdsHealthcareservicesHcsIdPositions } from '@toktokdoctech/tokapi-client'
import styles from '../../Common/_styles/filterListStyles'
import { useButtonsStyles, useFormsStyles } from '../../../styles'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { CaregiverListFilterProps, CaregiverFilters } from './_types'
import { toggleFilterArrayInPlace } from '../../../utils/filters'


// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { root: { flexGr... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

export const CaregiverListFilters = ({ filters, onChange }: CaregiverListFilterProps) => {
    const classes = useStyles()
    const buttonsClasses = useButtonsStyles()
    const formsClasses = useFormsStyles()

    const [anchorEl, setAnchorEl] = useState(null)
    const menuOpen = Boolean(anchorEl)
    const { id: hcsId } = useCurrentHcs()
    const { data: positions } = useGetIdsHealthcareservicesHcsIdPositions(hcsId, {
      query: { queryKey: ['hcspositions', hcsId] } // cache positions
    })

    const hasFilterActive = filters.positions.length > 0 || filters.roles.length > 0 // does not consider search

    const { data: roles } = useGetIdsReferencesHcsroles()

    const getRoleIdByRoleName = (roleName: string): string | undefined => {
        if (!roles) return undefined
        const foundRole = roles.find((role) => role.name === roleName)
        return foundRole?.id
    }

    const isRoleSelected = (roleName: string) => {
        const roleId = getRoleIdByRoleName(roleName)
        if (!roleId) return false
        return filters.roles.includes(roleId)
    }

    const handleMenu = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSearchChange = useCallback(
        _.debounce((value: any) => {
            handleFiltersChange({ search: value })
        }, 300),
        [_.debounce],
    )

    const handleRoleChange = (value: string) => {
        if (!roles) return

        const roleId = getRoleIdByRoleName(value)
        if (!roleId) return
        toggleFilterArrayInPlace(filters.roles, roleId)
        handleFiltersChange(filters)
    }

    const handlePositionsChange = (value: string) => {
        toggleFilterArrayInPlace(filters.positions, value)
        handleFiltersChange(filters)
    }

    const handleFiltersChange = (newFilters: Partial<CaregiverFilters>) => {
        onChange({ ...filters, ...newFilters })
    }

    const handleResetFilter = () => {
        onChange({ search: filters.search, roles: [], positions: [] })
    }

    return (
        <>
            <TextField
                variant="outlined"
                className={formsClasses.SearchField}
                id="input-with-icon-adornment"
                data-cy="input-with-icon-adornment"
                onChange={(event) => {
                    const { value } = event.target
                    handleSearchChange(value)
                }}
                label={
                    <Typography className={formsClasses.SearchFieldLabel}>
                        <SearchRoundedIcon />
                        <span>Recherche par nom et prénom</span>
                    </Typography>
                }
                classes={{
                    // @ts-expect-error TS(2339) FIXME: Property 'input' does not exist on type 'ClassName... Remove this comment to see the full error message
                    root: classes.input,
                    // @ts-expect-error TS(2322) FIXME: Type '{ root: any; underline: any; }' is not assig... Remove this comment to see the full error message
                    underline: classes.underline,
                }}
            />
            <Button
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                className={clsx(hasFilterActive && buttonsClasses.ButtonActive, buttonsClasses.ButtonTextBlackFlat)}
                startIcon={<TuneRoundedIcon />}
            >
                <Hidden smDown>Filtrer</Hidden>
            </Button>
            <Menu
                id="menu-filters"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={menuOpen}
                onClose={handleClose}
                className={classes.menu}
            >
                <div className={formsClasses.FormContainer}>
                    <FormControl variant="standard" component="fieldset" className={formsClasses.FormControl}>
                        <FormGroup aria-label="position" className={formsClasses.FormGroup}>
                            <FormLabel component="legend">Fonction</FormLabel>
                            {positions?.items.map((position) => (
                                <FormControlLabel
                                    key={position.id}
                                    control={
                                        <Checkbox
                                            name="positions"
                                            value={position.id}
                                            checked={filters.positions.includes(position.id)}
                                            onChange={() => handlePositionsChange(position.id)}
                                        />
                                    }
                                    // @ts-expect-error TS(2339) FIXME: Property 'name' does not exist on type 'never'.
                                    label={position.name}
                                    labelPlacement="end"
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                    <FormControl variant="standard" component="fieldset" className={formsClasses.FormControl}>
                        <FormGroup aria-label="position" className={formsClasses.FormGroup}>
                            <FormLabel component="legend">Rôle</FormLabel>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="role"
                                        value={1}
                                        checked={isRoleSelected('Gestionnaire')}
                                        onChange={() => handleRoleChange('Gestionnaire')}
                                    />
                                }
                                label="Gestionnaire"
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="role"
                                        value={2}
                                        checked={isRoleSelected('Utilisateur')}
                                        onChange={() => handleRoleChange('Utilisateur')}
                                    />
                                }
                                label="Utilisateur"
                                labelPlacement="end"
                            />
                        </FormGroup>
                    </FormControl>
                    {hasFilterActive && (
                        <div className={formsClasses.FormContainerBottom}>
                            <Button
                                color="inherit"
                                className={formsClasses.FormContainerBottomResetButton}
                                onClick={() => handleResetFilter()}
                            >
                                Réinitialiser les filtres
                            </Button>
                        </div>
                    )}
                </div>
            </Menu>
        </>
    )
}
